import { Label, Rule } from '../design/Paper';
import {
  PhoneAdmin,
  PhoneJoin,
  PhoneVoted,
  PhoneVoting,
  ProjectorChaos,
  ProjectorLobby,
  ProjectorRevealed,
  ProjectorVoting,
} from './Mocks';

/** All mock screens on one page, at their real aspect ratios. Reachable at /mocks. */

function Frame({
  title,
  note,
  ratio,
  children,
}: {
  title: string;
  note: string;
  ratio: string;
  children: React.ReactNode;
}) {
  return (
    <figure className="m-0">
      <figcaption className="mb-2">
        <Label className="text-[0.7rem]">{title}</Label>
        <p className="mt-1 text-xs text-ink-faint">{note}</p>
      </figcaption>
      <div
        className="overflow-hidden border-[3px] border-ink"
        style={{ aspectRatio: ratio }}
      >
        {children}
      </div>
    </figure>
  );
}

export function MockGallery() {
  return (
    <div className="min-h-screen bg-paper-sunk px-6 py-10">
      <div className="mx-auto max-w-[1500px]">
        <h1 className="font-display text-3xl uppercase">Ecrane — machete</h1>
        <p className="mt-1 text-sm text-ink-soft">
          Proiector 16:9, telefon 9:19.5. Date fictive, fără animații.
        </p>
        <Rule className="mt-4 mb-9" />

        <div className="grid gap-9 lg:grid-cols-2">
          <Frame title="Proiector · vot în desfășurare" note="Se vede cine a votat, nu ce a votat." ratio="16/9">
            <ProjectorVoting />
          </Frame>
          <Frame title="Proiector · dezvăluire" note="Toate voturile, atribuite, simultan." ratio="16/9">
            <ProjectorRevealed />
          </Frame>
          <Frame title="Proiector · haos" note="Acoperă ecranul până la următorul vot." ratio="16/9">
            <ProjectorChaos />
          </Frame>
          <Frame title="Proiector · lobby" note="QR de intrare plus lista de jucători." ratio="16/9">
            <ProjectorLobby />
          </Frame>
        </div>

        <Rule className="my-10" />

        <div className="grid gap-9 sm:grid-cols-2 lg:grid-cols-4">
          <Frame title="Telefon · intrare" note="Nume și poză opțională." ratio="9/19.5">
            <PhoneJoin />
          </Frame>
          <Frame title="Telefon · vot" note="Două ținte mari pentru degete." ratio="9/19.5">
            <PhoneVoting />
          </Frame>
          <Frame title="Telefon · a votat" note="Votul propriu, blocat." ratio="9/19.5">
            <PhoneVoted />
          </Frame>
          <Frame title="Telefon · administrare" note="Dens intenționat." ratio="9/19.5">
            <PhoneAdmin />
          </Frame>
        </div>
      </div>
    </div>
  );
}
